import { useRpiGraphqlRequest } from "@rpi/openapi-api";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type Year = number;

type YearlyOrderMetricsVariables = {
  customerPublicId: string;
};

export type YearlyOrderMetrics = {
  yearlyOrderMetrics: {
    customerPublicId: string;
    yearsAvailable: Year[];
    years: Record<
      Year,
      {
        year: Year;
        months: {
          month: string;
          inProgress: number;
          shipped: number;
          printing: number;
          failed: number;
        }[];
      }
    >;
  };
};

const YtdOrdersDocument = `
    query YearlyOrderMetrics($customerPublicId: String!) {
  yearlyOrderMetrics(customerPublicId: $customerPublicId) {
    customerPublicId
    yearsAvailable
    years {
        year
        months {
            month
            inProgress
            shipped
            printing
            failed
        }
    }
  }
}
    `;

export const useYtdOrdersQuery = (
  variables: YearlyOrderMetricsVariables,
  options?: UseQueryOptions<YearlyOrderMetrics>
) =>
  useQuery<YearlyOrderMetrics>(
    ["YearlyOrderMetrics", variables],
    useRpiGraphqlRequest<YearlyOrderMetrics, YearlyOrderMetricsVariables>(YtdOrdersDocument).bind(null, variables),
    options
  );

type YearlyPaymentMetricsVariables = {
  customerPublicId: string;
};

export type YearlyPaymentMetrics = {
  yearlyPaymentMetrics: {
    customerPublicId: string;
    nextChargeDate: string;
    yearsAvailable: Year[];
    years: Record<
      Year,
      {
        year: Year;
        months: {
          month: string;
          totalPaymentAmount: number;
        }[];
      }
    >;
  };
};

const YtdPaymentsDocument = `
      query YearlyPaymentMetrics($customerPublicId: String!) {
    yearlyPaymentMetrics(customerPublicId: $customerPublicId) {
      customerPublicId
      nextChargeDate
      yearsAvailable
      years {
          year
          months {
              month
              totalPaymentAmount
          }
      }
    }
  }
      `;

export const useYtdPaymentsQuery = (
  variables: YearlyPaymentMetricsVariables,
  options?: UseQueryOptions<YearlyPaymentMetrics>
) =>
  useQuery<YearlyPaymentMetrics>(
    ["YearlyPaymentMetrics", variables],
    useRpiGraphqlRequest<YearlyPaymentMetrics, YearlyPaymentMetricsVariables>(YtdPaymentsDocument).bind(
      null,
      variables
    ),
    options
  );
